import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';

import { BodyText3, FlexRow, InternalLink, PageBody } from '@portal/common/components';
import { styled } from '@portal/common/theme';
import { checkIsLicenseExpired } from '@portal/common/utility/license-helpers';

import LicenseMessageTile from '../components/LicenseMessageTile';
import _ from '../locale';
import { getOrganization } from '../store/organization/selectors';
import { CONTACT_US_PATH } from './paths';

const ContactUs = styled(FlexRow)({
    marginTop: 18,
});

const LicensedRoute: FC = () => {
    const organization = useSelector(getOrganization);

    if (!organization) {
        return <Outlet />;
    }

    if (!checkIsLicenseExpired(organization)) {
        return <Outlet />;
    }

    const LinkToContactUs = (props) => <InternalLink {...props} to={CONTACT_US_PATH} />;

    return (
        <PageBody noHeaderSpacing>
            <LicenseMessageTile title={_('license_is_expired')}>
                <BodyText3>
                    {_('license_for_organization_is_expired', { organization: organization.name })}
                </BodyText3>
                <ContactUs>
                    <BodyText3>{_('contact_us_for_new_license')(LinkToContactUs)}</BodyText3>
                </ContactUs>
            </LicenseMessageTile>
        </PageBody>
    );
};

export default LicensedRoute;
